import { EventContext, Fields, Versions } from '@vimeo/bigpicture-client';
import { createNullObject, PartialWithRequired } from '@vimeo/use-tracking';

export const liveBpContextName = 'live_context';
type LiveVersions = Versions<typeof liveBpContextName>;

const defaults = createNullObject([
  'recurring_live_event_id',
  'live_event_id',
  'live_status',
  'live_production_method',
  'encoder_type',
  'audience_type',
  'lead_source',
  'event_privacy',
  'live_feature',
  'is_guest_speaker',
]);

export const buildLiveBpContext = <V extends LiveVersions>(
  fields: PartialWithRequired<Fields<typeof liveBpContextName, V>, 'recurring_live_event_id'>,
  contextVersion: V,
) => {
  return {
    live_context: new EventContext(liveBpContextName, contextVersion as any, {
      ...defaults,
      ...fields,
    }),
  };
};
